import { TxKeyPath } from "@/models/i18n/TxKeyPath";
import { createContext } from "react";

// Define the type for LanguageContext
export type ContentContextType = {
  t: (tx: TxKeyPath) => string;
};

// Create a LanguageContext
export const ContentContext = createContext<ContentContextType | null>(null);
